import { withStyles } from '@mui/styles';
import ModalBase from './ModalBase';
import styles from './styles';

const Styled = withStyles(styles)(ModalBase);

export default Styled;
